import * as api from '@/api/jxCourse'
import * as TYPES from './type';

export default {
  //教学课程
  async getCourseList({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqCourseList(paramets)
    commit(TYPES.COURSE_LIST, {
      result
    })
    cb && cb()
  },
  async getCourseNames({
    commit,
    state
  }, {
    paramets,
    cb,
    cbParamets = {}
  }) {
    const result = await api.reqCourseNames(paramets)
    commit(TYPES.COURSE_INFO, {
      result,
      type: 'names'
    })
    cb && cb(...cbParamets)
  },
  async getCourseInfo({
    commit,
    state
  }, {
    paramets,
    type,
    cb
  }) {
    const result = await api.reqCourseInfo(paramets)
    commit(TYPES.COURSE_INFO, {
      result,
      type
    })
    cb && cb()
  },
  async getCoverList({
    commit,
    state
  }, cb) {
    const result = await api.reqCourseCover()
    commit(TYPES.COURSE_INFO, {
      result,
      type: 'cover'
    })
    cb && cb()
  },
  async postCourseAdd({
    commit,
    state
  }, {
    paramets,
    cb,
  }) {
    const result = await api.reqCourseAdd(paramets)
    commit(TYPES.COURSE_INFO, {
      result,
      type: 'add'
    })
    cb && cb()
  },
  async putCourseEdit({
    commit,
    state
  }, {
    paramets,
    cb,
    cbParamets = {}
  }) {
    const result = await api.reqCourseEdit(paramets)
    commit(TYPES.COURSE_INFO, {
      result,
      type: 'edit'
    })
    cb && cb(...cbParamets)
  },
  async deleteCourseDel({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqCourseDel(paramets)
    commit(TYPES.COURSE_INFO, {
      result,
      type: 'del'
    })
    cb && cb()
  },
  async getRoleByCourseId({
    commit,
    state
  }, {
    paramets,
    cb,
    cbParamets = {}
  }) {
    const result = await api.reqRoleByCourseId(paramets)
    commit(TYPES.COURSE_INFO, {
      result,
      type: 'role'
    })
    cb && cb(...cbParamets)
  },
  async getCourseById({
    commit,
    state
  }, {
    paramets,
    cb,
    cbParamets = {}
  }) {
    const result = await api.reqCourseById(paramets)
    commit(TYPES.COURSE_INFO, {
      result,
      type: 'course'
    })
    cb && cb(...cbParamets)
  },
  async getCourseGroupById({
    commit,
    state
  }, {
    paramets,
    cb,
  }) {
    const result = await api.reqCourseGroupById(paramets)
    commit(TYPES.COURSE_INFO, {
      result,
      type: 'group'
    })
    cb && cb()
  },
  async putCourseEditPermission({
    commit,
    state
  }, {
    paramets,
    cb,
    cbParamets = {}
  }) {
    const result = await api.reqCourseEditPermission(paramets)
    commit(TYPES.COURSE_INFO, {
      result,
      type: 'permission'
    })
    cb && cb(...cbParamets)
  },
  async deleteCourseDelPermissionById({
    commit,
    state
  }, {
    paramets,
    cb,
    cbParamets = {}
  }) {
    const result = await api.reqCourseDelPermissionById(paramets)
    commit(TYPES.COURSE_INFO, {
      result,
      type: 'del'
    })
    cb && cb(...cbParamets)
  },
  async deleteCourseDelPermissionBatch({
    commit,
    state
  }, {
    paramets,
    cb,
    cbParamets = {}
  }) {
    const result = await api.reqCourseDelPermissionBatch(paramets)
    commit(TYPES.COURSE_INFO, {
      result,
      type: 'del'
    })
    cb && cb(...cbParamets)
  },
  async getCourseRootChapter({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqCourseRootChapter(paramets)
    commit(TYPES.COURSE_CHAPTER, {
      result,
      type: 'root'
    })
    cb && cb()
  },
  async getCourseChildChapter({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqCourseChildChapter(paramets)
    commit(TYPES.COURSE_CHAPTER, {
      result,
      type: 'child'
    })
    cb && cb()
  },
  async getCourseCatalogTreeList({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqCourseCatalogTreeList(paramets)
    commit(TYPES.COURSE_CHAPTER, {
      result,
      type: 'treeList'
    })
    cb && cb()
  },
  async postCourseChapter({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqCourseAddChapters(paramets)
    commit(TYPES.COURSE_CHAPTER, {
      result,
      type: 'add'
    })
    cb && cb()
  },
  async putCourseChapter({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqCourseEditChapters(paramets)
    commit(TYPES.COURSE_CHAPTER, {
      result,
      type: 'edit'
    })
    cb && cb()
  },
  async deleteCourseChapter({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqCourseDelChapters(paramets)
    commit(TYPES.COURSE_CHAPTER, {
      result,
      type: 'delete'
    })
    cb && cb()
  },
  async deleteBatchCourseChapter({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqCourseDelBatchChapters(paramets)
    commit(TYPES.COURSE_CHAPTER, {
      result,
      type: 'deleteBatch'
    })
    cb && cb()
  },
  async getCourseSortChapter({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqCourseSortChapters(paramets)
    commit(TYPES.COURSE_CHAPTER, {
      result,
      type: 'delete'
    })
    cb && cb()
  },
  async getCourseFromResLibrary({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqCourseFromResLibrary(paramets)
    commit(TYPES.COURSE_CHAPTER_RES, {
      result,
      type: 'library'
    })
    cb && cb()
  },

  async delCourseFromResLibrary({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqCourseFromResLibraryDel(paramets)
    console.log(result)
    commit(TYPES.COURSE_CHAPTER_RES, {
      result,
      type: 'libraryDel'
    })
    cb && cb()
  },

  async postCourseResAdd({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqCourseResAdd(paramets)
    commit(TYPES.COURSE_CHAPTER_RES, {
      result,
      type: 'add'
    })
    cb && cb()
  },

  clearcourseChapter({
    commit,
    state
  }) {
    commit(TYPES.COURSE_CHAPTER, {
      result: '',
      type: 'root'
    })
  },

  async getSystemMajor(context, {
    paramets,
    cb
  }) {
    const result = await api.reqSystemMajorList(paramets)
    context.commit(TYPES.SYSTEM_MAJOR, result)
    cb && cb()
  },
  async postCourseResAddList(context, {
    paramets,
    cb
  }) {
    const result = await api.reqCourseResAddList(paramets)
    context.commit(TYPES.COURSE_MENU_LIST, result)
    cb && cb()
  },
  async getCourseGroupList({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqCourseGroupList(paramets)
    commit(TYPES.COURSE_INFO, {
      result,
      type: 'groupList'
    })
    cb && cb()
  },
  async postCourseGroupAdd({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqCourseGroupAdd(paramets)
    commit(TYPES.COURSE_INFO, {
      result,
      type: 'groupListAdd'
    })
    cb && cb()
  },
  async putCourseGroupLeader({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqCourseGroupLeader(paramets)
    commit(TYPES.COURSE_INFO, {
      result,
      type: 'groupListLeader'
    })
    cb && cb()
  },
  async postCourseAddCourseRes({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqCourseAddCourseRes(paramets)
    commit(TYPES.COURSE_INFO, {
      result,
      type: 'addCourseRes'
    })
    cb && cb()
  },
  async getCourseDetailCourseRes({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqCourseDetailCourseRes(paramets)
    commit(TYPES.COURSE_INFO, {
      result,
      type: 'detailCourseRes'
    })
    cb && cb()
  },
  async putCourseEditCourseRes({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqCourseEditCourseRes(paramets)
    commit(TYPES.COURSE_INFO, {
      result,
      type: 'detailCourseRes'
    })
    cb && cb()
  },
  async getCourseMaterialList({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqCourseMaterialList(paramets)
    commit(TYPES.COURSE_MATERIAL_INFO, {
      result,
      type: 'list'
    })
    cb && cb()
  },
  async postUpdateCatalog({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqUpdateCatalog(paramets)
    commit(TYPES.COURSE_MATERIAL_INFO, {
      result,
      type: 'update'
    })
    cb && cb()
  },
  async getCourseMaterialRootList({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqCourseMaterialRootList(paramets)
    commit(TYPES.COURSE_MATERIAL_INFO, {
      result,
      type: 'root'
    })
    cb && cb()
  },
  async getCourseMaterialChildList({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqCourseMaterialChildList(paramets)
    commit(TYPES.COURSE_MATERIAL_INFO, {
      result,
      type: 'child'
    })
    cb && cb()
  },

  async getUpdateBooklistCatalog({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqUpdateBooklistCatalog(paramets)
    commit(TYPES.COURSE_MATERIAL_INFO, {
      result,
      type: 'book'
    })
    cb && cb()
  },

  async getCourseMaterialDropDownList({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqCourseMaterialDropDownList(paramets)
    commit(TYPES.COURSE_MATERIAL_INFO, {
      result,
      type: paramets.type
    })
    cb && cb()
  },

  async getCourseCloseList({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqCourseCloseList(paramets)
    commit(TYPES.COURSE_CLOSE, {
      result,
      type: 'list'
    })
    cb && cb()
  },

  async addCourseCloseAdd({
    commit,
    state
  }, {
    paramets,
    cb
  }) {
    const result = await api.reqCourseCloseAdd(paramets)
    commit(TYPES.COURSE_CLOSE, {
      result,
      type: 'add'
    })
    cb && cb()
  },
}



// WEBPACK FOOTER //
// ./src/store/jxCourse/actions.js